import React, { useRef, useEffect, useState } from 'react';
import { JumbotronTypes } from '../../jumbotronTypes';
import { LocationMap, LocationTypes } from '../../../../../sitewide';
import { useJumbotronContext } from '../../context/jumbotronContext';
import {
  JumbotronTitleAndLocationSelectMultiLocation,
  JumbotronTitleAndLocationSelectSingleLocation,
} from './BackgroundHelper';
import { CPImage } from '../../../../../../components/imageWrapper/CPImage';
import { mobilescreensize } from '../../../../../../utilities/constants';
import Carousel, { CarouselItem } from '../carousel/Carousel';
import { Image } from '@codeparva/ui-components-library';
import { weakKey } from '../../../../../../utilities/weakKey';

export const Background = ({
  media,
  locationMapConfig,
  headHeight,
  variant,
  contactDetails,
  setLocationData,
  setSelectedLocation,
  width,
}: JumbotronTypes.IBackground) => {
  const jumbotronContext = useJumbotronContext();
  const ref = useRef<any>(null);
  const [dropDownState, setDropDownState] = useState(false);
  const [divHeight, setDivHeight] = useState(90);
  let { locationData, selectedLocation, variantType } = jumbotronContext;
  useEffect(() => {
    if (ref && ref.current) {
      setDivHeight(ref.current.clientHeight);
    }
  }, [dropDownState]);
  const onDropDownButton = () => {
    setDropDownState(!dropDownState);
    const filteredLocationData = locationData.filter(
      location => location.address[0].data !== selectedLocation.address[0].data
    );
    setLocationData(filteredLocationData);
  };
  const selectItemFromDropDown = (selectedLocation: any) => {
    setSelectedLocation(selectedLocation);
    setDropDownState(!dropDownState);
    setLocationData(contactDetails);
  };
  const JumbotronTitleAndLocationSelect = ({
    isImage,
  }: JumbotronTypes.TImageURL) => {
    return variantType === 'single'
      ? contactDetails && (
          <JumbotronTitleAndLocationSelectSingleLocation
            contactDetails={contactDetails}
            isImage={isImage}
          />
        )
      : contactDetails && (
          <JumbotronTitleAndLocationSelectMultiLocation
            selectedLocation={selectedLocation}
            isImage={isImage}
            locationData={locationData}
            dropDownState={dropDownState}
            onDropDownButton={onDropDownButton}
            selectItemFromDropDown={selectItemFromDropDown}
            ref={ref}
          />
        );
  };
  const JumbotronTitleAndLocation = ({ isImage }: boolean | any) => {
    return <JumbotronTitleAndLocationSelect isImage={isImage} />;
  };
  const image = media.imagesSrc[0];
  const isImage = image ? true : false;
  const getHeight = () => {
    return width <= mobilescreensize
      ? isImage && image
        ? '50vh'
        : '280px'
      : isImage && image
      ? 'auto'
      : '280px';
  };
  const RenderImage = () => {
    return image ? (
      <div
        className="BackgroundImage"
        style={{
          display: 'grid',
          maxHeight: 'fit-content',
        }}
      >
        <div className="BackgroundImageDiv">&nbsp;</div>
        <JumbotronTitleAndLocation isImage={isImage} />
        <CPImage
          gatsbyImageData={image}
          style={{
            gridArea: '1/1',
            marginTop: `-${divHeight}px`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            height: getHeight(),
            maxHeight: 'fit-content',
          }}
        />
      </div>
    ) : (
      <div
        className="BackgroundNoImage"
        style={{
          height: getHeight(),
        }}
      >
        <JumbotronTitleAndLocation isImage={isImage} />
      </div>
    );
  };

  const RenderVideo = () => {
    return (
      <video
        autoPlay
        muted
        loop
        controls
        style={{ height: headHeight, minHeight: headHeight }}
      >
        <source src={`${media?.video?.src}`} type="video/mp4" />
      </video>
    );
  };

  const RenderCarousel = ({ media }: any) => {
    return (
      <>
        <div
          style={{
            position: 'absolute',
            zIndex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            right: 0,
            left: 0,
            height: '100%',
          }}
        >
          <JumbotronTitleAndLocation isImage={false} />
        </div>
        <Carousel>
          {media &&
            media.map((imagesSrc: any) => {
              return (
                <CarouselItem width="100%" key={weakKey(imagesSrc)}>
                  <div className="jumboCarouselContainer">
                    {imagesSrc.gatsbyImageData ? (
                      <CPImage gatsbyImageData={imagesSrc.gatsbyImageData} />
                    ) : (
                      <Image
                        src={imagesSrc.imgProps.src}
                        style={{
                          gridArea: '1/1',
                          marginTop: `-${divHeight}px`,
                          backgroundRepeat: 'no-repeat',
                          backgroundSize: 'cover',
                          height: getHeight(),
                          maxHeight: 'fit-content',
                        }}
                      />
                    )}
                  </div>
                </CarouselItem>
              );
            })}
        </Carousel>
      </>
    );
  };

  const RenderMapSection = () => {
    const backGroundConfig: LocationTypes.ILocationMap = {
      ...locationMapConfig,
      variant: 'cover-image',
      fullWidth: false,
    };
    return (
      <div className="MapSection" style={{ height: headHeight }}>
        <RenderImage />
        <LocationMap {...backGroundConfig} />
      </div>
    );
  };

  const RenderBG = () => {
    const src = media?.video?.src
      ? 'video'
      : Object.keys(media?.imagesSrc).length <= 1
      ? 'image'
      : 'carousel';
    if (variant === 'singleLocationWithMap') {
      return <RenderMapSection />;
    } else {
      switch (src) {
        case 'image':
          return <RenderImage />;
        case 'video':
          return <RenderVideo />;
        case 'carousel':
          return <RenderCarousel media={media?.imagesSrc} />;
        default:
          return <RenderImage />;
      }
    }
  };

  return (
    <div
      className={`${
        variant === 'multiLocationListOfCard'
          ? 'jumbotronHalfBG'
          : 'jumbotronFullBG'
      }`}
    >
      <RenderBG />
    </div>
  );
};
